import { Navigate, useLocation, useParams, useRoutes } from "react-router-dom";

import EditPage from "./edit";
import IndexPage from "./index";
import ViewPage from "./view";

export default () =>
  useRoutes([
    { path: "/search/:search", element: <WithParameters component={IndexPage}/> },
    { path: "/new", element: <WithParameters component={EditPage}/> },
    { path: "/:feedId/edit", element: <WithParameters component={EditPage}/> },
    { path: "/:feedId", element: <WithParameters component={ViewPage}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  const loc = useLocation();
  return <Comp {...parameters} location={loc}/>;
}
